import { literal } from "../../shared/src/codecs/types/literal";
import { union } from "../../shared/src/codecs/types/union";

export const ListingMarketingRoute = union([
    literal("direct"),
    literal("appointed_agent"),
]);
